import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { emailTemplateSchema } from '../models/emailTemplate.schema';
import { emailTemplateListQuerySchema } from './list.schema';

export type EmailTemplateListQuery = {
  pageSize?: number;
  page?: number;
  fields?: string[];
  ordering?: string[];
  queue?: number | number[];
};

export const list = (query: EmailTemplateListQuery = {}) => {
  return {
    endpoint: `/email_templates`,
    method: 'GET',
    responseSchema: listResponse(emailTemplateSchema),
    query: { ...query, includeTotal: true },
    querySchema: emailTemplateListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
